import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getIdToken } from '../../services/firebase';
import {
  getKiddowareAccountUrl,
  KIDDOWARE_ACCOUNT_URL,
  SEARCH_LICENSE_PRODUCT_LABELS,
  SEARCH_LICENSE_UPGRADE_HINT,
} from '../../config/kiddowareUrls';
import { trackUserAction } from '../../utils/analytics';

const panelStyle = {
  maxWidth: 420,
  margin: '32px auto',
  padding: 28,
  borderRadius: 16,
  border: '1px solid var(--color-border)',
  background: 'var(--color-bg-card)',
  boxShadow: '0 4px 24px var(--color-shadow)',
  textAlign: 'center',
};

const primaryBtn = {
  display: 'inline-block',
  padding: '12px 18px',
  borderRadius: 10,
  background: 'var(--color-primary)',
  color: '#fff',
  fontWeight: 700,
  textDecoration: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: 15,
};

const secondaryLink = {
  display: 'inline-block',
  marginTop: 10,
  fontSize: 13,
  color: 'var(--color-primary)',
  fontWeight: 700,
};

function SearchAccessBlockedPanel({ reason }) {
  const [upgradeUrl, setUpgradeUrl] = useState(KIDDOWARE_ACCOUNT_URL);

  useEffect(() => {
    getIdToken().then((token) => setUpgradeUrl(getKiddowareAccountUrl(token || undefined)));
  }, []);

  const openUpgrade = () => {
    trackUserAction.externalLink('search_blocked_upgrade');
    window.open(upgradeUrl, '_blank', 'noopener,noreferrer');
  };

  if (reason === 'auth_required') {
    return (
      <div style={panelStyle}>
        <div style={{ fontSize: 44, marginBottom: 12 }} aria-hidden>
          🔐
        </div>
        <h2 style={{ margin: '0 0 12px', fontSize: '1.25rem' }}>Sign in to search</h2>
        <p style={{ margin: '0 0 18px', lineHeight: 1.55, opacity: 0.85 }}>
          Web search requires a signed-in Kiddoware account with an active{' '}
          {SEARCH_LICENSE_PRODUCT_LABELS.kw} or {SEARCH_LICENSE_PRODUCT_LABELS.kpsb} license.
        </p>
        <Link to="/auth" style={primaryBtn}>
          Sign in
        </Link>
      </div>
    );
  }

  if (reason === 'license_required') {
    return (
      <div style={panelStyle}>
        <div style={{ fontSize: 44, marginBottom: 12 }} aria-hidden>
          ⭐
        </div>
        <h2 style={{ margin: '0 0 12px', fontSize: '1.25rem' }}>License required for search</h2>
        <p style={{ margin: '0 0 18px', lineHeight: 1.55, opacity: 0.85 }}>
          {SEARCH_LICENSE_UPGRADE_HINT} Upgrade your account at{' '}
          <strong>app.kiddoware.com</strong> — only <strong>Kiddoware (kw)</strong> and{' '}
          <strong>Kids Place Safe Browser (kpsb)</strong> plans include supervised web search.
        </p>
        <button type="button" onClick={openUpgrade} style={primaryBtn}>
          Upgrade at app.kiddoware.com
        </button>
        <div>
          <Link to="/settings" style={secondaryLink}>
            View license status in Settings
          </Link>
        </div>
      </div>
    );
  }

  if (reason === 'service_error') {
    return (
      <div style={panelStyle}>
        <div style={{ fontSize: 44, marginBottom: 12 }} aria-hidden>
          ⚠️
        </div>
        <h2 style={{ margin: '0 0 12px', fontSize: '1.25rem' }}>Search check unavailable</h2>
        <p style={{ margin: '0 0 18px', lineHeight: 1.55, opacity: 0.85 }}>
          We could not reach the search safety check right now. Try again in a moment, or ask a
          grown-up for help.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={primaryBtn}
        >
          Try again
        </button>
      </div>
    );
  }

  return null;
}

export default SearchAccessBlockedPanel;
